import { createLogger } from '@bank/monitoring';

import { getEnv } from '@/utils/env';

export const { logError, logInfo, initMonitoring } = createLogger({
  environment: getEnv(),
  datadog: {
    appId: 'ee4578a7-cbd1-4ad0-b346-f9a981459d72',
    appName: window.env.CLIENT_ID,
    appVersion: __APP_VERSION__.toLowerCase(),
    clientPublicToken: 'pubeb1da1e3857ff5ba18cf9b2e15142178',
  },
  sentry: {
    dsn: window.env.SENTRY_DSN,
    release: __APP_VERSION__,
  },
});
